import {
  Person,
  Phone,
  Logout,
  Email,
  Settings,
  Work,
  Edit,
} from '@mui/icons-material'
import { doLogout } from 'feature/auth/redux/action/doLogout'
import { formatPhoneNumber } from 'helpers/phones'
import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { Button, IconButton } from 'ui'
import { LoaderInCentalPosition } from 'widget'
import { MenuBlockWithIcon } from 'widget/MenuBlockWithIcon/MenuBlockWithIcon'

import { ModalConfirm } from 'feature/user/components/ModalConfirm/ModalConfirm'
import { useGetFitterQuery } from 'feature/user/redux/fitter.api'

import { useThunkDispatch } from 'store/hooks/useThunkDispatch'
import style from './FitterSettings.module.scss'

export function FitterSettings() {
  const navigate = useNavigate()
  const [isModalOpen, setModalOpen] = useState<boolean>(false)
  const handleOpenModal = () => setModalOpen(true)

  const { data, isLoading } = useGetFitterQuery()

  const thunkDispatch = useThunkDispatch()
  const logOutHandler = () => {
    thunkDispatch(doLogout())
    navigate('/login')
  }

  const fatherName = data?.fatherName ? data.fatherName : ''

  if (isLoading && !data) return <LoaderInCentalPosition />
  if (!data) return <></>

  return (
    <section className={style.settingPage}>
      <div>
        <div className={style.title}>
          <Settings color='primary' />
          <span className='h1'>Профиль</span>
          <IconButton
            onClick={() => navigate('/settings/fitter')}
            LinkComponent={Link}
          >
            <Edit color='primary' />
          </IconButton>
        </div>
        <div className={style.settingMenu}>
          <MenuBlockWithIcon
            text={`${data.lastName} ${data.firstName} ${fatherName}`}
            subText={data.locationAddress}
            startIcon={<Person color='primary' />}
            disabled
          />

          <MenuBlockWithIcon
            link={data.name.length ? '' : '/'}
            text={data.name.length ? data.name : 'Название компании'}
            disabled
            startIcon={<Work color='primary' />}
          />

          <MenuBlockWithIcon
            text={formatPhoneNumber(data.phone)}
            disabled
            startIcon={<Phone color='primary' />}
          />

          <MenuBlockWithIcon
            text={data.email || 'E-mail'}
            disabled
            startIcon={<Email color='primary' />}
          />
        </div>
      </div>

      <Button
        startIcon={<Logout color='primary' />}
        variant='contained'
        color='secondary'
        type='button'
        onClick={handleOpenModal}
        className={style.logoutBtn}
      >
        Выйти
      </Button>

      <ModalConfirm
        onConfirm={logOutHandler}
        cancelText='Отмена'
        actionText='Да'
        isModalOpen={isModalOpen}
        onCancel={() => setModalOpen(false)}
      />
    </section>
  )
}
